// Copyright (c) 2023 Jürgen Gebath
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT
import { Box, Grid, Typography } from "@mui/material";

function History(props) {
  return (
    <Grid
      container
      spacing={2}
      sx={(theme) => ({
        [theme.breakpoints.down("sm")]: {
          marginTop: 7,
        },
        [theme.breakpoints.up("sm")]: {
          marginTop: 20,
        },
      })}>
      <Grid
        item
        marginTop={2}
        xs={12}>
        <Typography
          variant="h5"
          component="h2">
          Geschichte der Wehr
        </Typography>
        <Typography variant="body2">
          <strong>1898 fand die Gründungsversammlung</strong> der FF Großrust
          statt. "Anläßlich des fünfzigjährigen Regierungs-Jubiläums Sr.
          Majestät unseres erhabenen Monarchen wurde in unserem Orte eine
          freiwillige Feuerwehr unter der Leitung des Herrn Oberlehrers Franz
          Weidlich gegründet, welche am 25. September 1898 unter zahlreicher
          Beteiligung der benachbarten Feuerwehren und der Bevölkerung aus nah
          und fern das Gründungsfest feierte." (
          <i>Mittheilungen des n.-ö Landes-Feuerwehr-Verbandes</i>) Insgesamt
          waren 14 Wehren mit 159 Mann anwesend.
        </Typography>
        <br />
        <Typography variant="body2">
          1899 war der erste Einsatz der Wehr: Brand in Schweinern Nr. 1 (Josef
          Schabasser).
        </Typography>
        <br />
        <Typography variant="body2">
          <strong>1. Weltkrieg:</strong> Während des Krieges wurden - aufgrund
          von "Mannschaftsmangel" - mehrere Männer aufgefordert, der Wehr
          beizutreten (Leopold Eichinger, Leopold Hell, Anton Strohmeier,
          Leopold Stiegler, Mühleitner Josef, Dazinger Anton und Hohenthoner
          Franz), aber auch die Jüngeren lud man zur Wehr ein (Stern Franz, Eckl
          Johann, Haas Alois, Mittenhuber Josef, Binder Josef, Dorner Alois und
          Stern Franz). Zu Kriegsdienstleistungen wurden aus der Wehr 30 Mann
          herangezogen, von denen 3 fielen (Unfried Karl, Papst Anton und
          Brothuber Johann), 5 in Gefangenschaft gerieten, einer vermisst und 3
          verwundet wurden. Einer kehrte invalid zurück.
        </Typography>
        <br />
        <Typography variant="body2">
          <strong>2. Weltkrieg:</strong> Aufgrund der Kriegswirren stellte die
          Wehr ihre Tätigkeit mit 30. Dezember 1939 ein. "Nach den schrecklichen
          Ereignissen des Krieges wurde unsere Feuerwehr am 28. Juli 1946 wieder
          ins Leben gerufen, um dem alten Wahlspruch: Einer für alle, alle für
          Einen gerecht zu werden." - so vermerkt das Protokollbuch.
        </Typography>
        <br />
        <Typography variant="body2">
          <strong>50-Jahrfeier</strong> am 26. September 1948: Gemeinsam mit den
          Wehren Kleinrust, Obritzberg, Hain, Karlstetten und Mamau wurde der
          "50er" mit Feldmesse und Schauübung gefeiert. Festredner:
          Bezirkskommandant Alois Wasmer.
        </Typography>
        <br />
        <Typography
          variant="h5"
          component="h3">
          Unsere Kommandanten bis zum Jahr 2023
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}>
        <Box
          component="img"
          src={process.env.PUBLIC_URL + "/images/kommandanten.jpg"}
          alt=""
          sx={{ maxWidth: "100%" }}
        />
      </Grid>
    </Grid>
  );
}

export default History;
